import { useEffect, useState } from 'react'
import { ServicesInput } from '../../../components/Services';
import { connect } from 'react-redux';
import { RootState } from '../../../redux/rootReducers';
import { panAadharLinkStatusAction } from '../../../redux/services/actions';
import { resetServicesError, resetPanAadharLinkStatus } from '../../../redux/services'
import { panAadharLinkType } from '../../../redux/services/serviceTypes'
import { getPanAadharLinkStatusType } from '../../../commonTypes/serviceTypes';

type AppProps = {
    dispatchPanAadharLinkStatus: (panAdharData: getPanAadharLinkStatusType) => void;
    dispatchresetServicesError: () => void;
    dispatchResetPanAadharLinkStatus: () => void;
    panAadharLinkStatus: panAadharLinkType | null;
    error?: string | null;
    fetching?: boolean;
    token: string | null;
}


const PanAadharLink = ({
    dispatchresetServicesError,
    dispatchResetPanAadharLinkStatus,
    panAadharLinkStatus,
    error,
    fetching,
    token
}: AppProps) => {

    useEffect(() => {
        dispatchresetServicesError();
        dispatchResetPanAadharLinkStatus();
    }, [])
    const [panNumber, setPanNumber] = useState<string>("")
    const [aadharNumber, setAadharNumber] = useState<string>("")

    const handlePanInput = (event: any) => {
        setPanNumber(event?.target.value)
    }
    const handleAadharInput = (event: any) => {

        setAadharNumber(event?.target.value)
    }

    const getLinkingDetails = () => {
        //commented for future use
        // let panAdharData = {
        //     pan_no: panNumber,
        //     aadhar_no: aadharNumber,
        //     token
        // }
        // dispatchPanAadharLinkStatus(panAdharData);
    }

    return (
        <div className="ifsc-wrap">
            <h2>PAN Aadhar Linking Status</h2>
            <div className="row">
                <div className="col-4  login-leftx " style={{ borderRadius: "8px" }}>
                    <ServicesInput
                        handleChange={handlePanInput}
                        placeholder="PAN number"
                        serviceType={panNumber}
                        autoFocus
                    />

                    <ServicesInput
                        handleChange={handleAadharInput}
                        placeholder="Aadhar Number"
                        serviceType={aadharNumber}
                    />
                    <button
                        className="btn btn-primary w-100 mt-2"
                        onClick={getLinkingDetails}
                    // disabled={ifscNumber?.length !== 11}
                    >
                        Submit
                    </button>
                </div>

                {panAadharLinkStatus
                    ? <div className="col-8">
                        <div className="card p-5 w-100">
                            <h3 className="info">
                                {panAadharLinkStatus.status}
                            </h3>

                        </div>

                    </div>
                    :
                    error
                        ? <div className="col-8">
                            <div className="card p-5 w-100">
                                <h3 className="error">
                                    {!!error ? error : 'No result Found!'}
                                </h3>

                            </div>
                        </div> : null
                }

                {fetching && <div className="text-center pt-5, mt-5">Loading...</div>}
            </div>
        </div>

    )
}

const mapStateToProps = (state: RootState) => ({
    panAadharLinkStatus: state.services.panAadharLinkStatus,
    fetching: state.services.fetching,
    error: state.services.error,
    token: state.auth.token
})

const mapDispatchToProps = (dispatch: any) => ({
    dispatchPanAadharLinkStatus: (panAdharData: getPanAadharLinkStatusType) => dispatch(panAadharLinkStatusAction(panAdharData)),
    dispatchresetServicesError: () => resetServicesError(),
    dispatchResetPanAadharLinkStatus: () => resetPanAadharLinkStatus()
})

export default connect(mapStateToProps, mapDispatchToProps)(PanAadharLink)